import React, { useState, useEffect } from 'react'
import { API, Auth } from 'aws-amplify';
import { NavLink} from "react-router-dom";
import "@aws-amplify/ui-react/styles.css";
import { Flex, Divider, Text, Heading, View, Button, TextField, SwitchField} from '@aws-amplify/ui-react';
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { multiRowSelection } from '../agGridRowSelection';
//import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import { themeQuartz } from 'ag-grid-community'; //import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import Loadingmini from '../components/loadingmini';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

export default function Userpricing({userJwt, refreshJwt, userId, fleetCode, isAdminOrFleet, onChanged}) {
    const [is_loading, updateIsLoading] = React.useState(false);
    const [display_form, updateDisplayForm] = React.useState(false);
    const [count, setCount] = useState(0);
    const [res, updateRes] = useState({});

    const [discountAmount, updateDiscountAmount] = useState(0);
    const [useDiscountStart, updateUseDiscountStart] = useState(false);
    const [discountStart, updateDiscountStart] = useState(false);
    const [discountStartFull, updateDiscountStartFull] = useState(false);
    const [useDiscountEnd, updateUseDiscountEnd] = useState(false);
    const [discountEnd, updateDiscountEnd] = useState(false);
    const [discountEndFull, updateDiscountEndFull] = useState(false);
    const [discountNotes, updateDiscountNotes] = useState("");
    const [discountOrPenalty, updateDiscountOrPenalty] = useState("discount");

    

    const columns = [
        {
            headerName: 'Datetime',
            field: 'created',
            filter: true
        },
        {
            headerName: 'Daily Amount',
            field: 'amount',
            filter: true
        },
        {
            headerName: 'Start',
            field: 'start',
            filter: true
        },
        {
            headerName: 'End',
            field: 'end',
            filter: true
        },
        {
            headerName: 'Status',
            field: 'status',
            filter: true,
            cellRenderer: (params) => {
                const row = params.data;
                if (!row?.id) return params.value || '';
                const next = row.status === 'active' ? 'inactive' : 'active';
                const label = next === 'inactive' ? 'Make inactive' : 'Make active';
                return (
                    <span>
                        {row.status || '—'}{' '}
                        <Button size="small" onClick={() => setStatus(row.id, next)}>{label}</Button>
                    </span>
                );
            }
        },
        {
            headerName: 'Provided by',
            field: 'updating_user_id',
            filter: true
        },
        {
            headerName: 'Notes',
            field: 'notes',
            filter: true
        }
    ];
  


    function handleStartDateSelected(date)
    {
        updateDiscountStartFull(date);
        const date2 = date.toISOString().substring(0, 10);
        updateDiscountStart(date2);
    }
    function handleEndDateSelected(date)
    {
        updateDiscountEndFull(date);
        const date2 = date.toISOString().substring(0, 10);
        updateDiscountEnd(date2);
    }

    async function fetchPageData() {
        if(userId > 0)
        {
            updateRes({status:"loading...",rows:[]})
            updateIsLoading(true)
            const myInit = {queryStringParameters:{ 
                "back_end": process.env.REACT_APP_BACKEND,
                "jwt": userJwt,
                "api_endpoint":"api3:portal:driver_desk",
                "section":"pricing",
                "request_type":"GET",
                "driver_id":userId,
                "fleet_code":fleetCode
            }};
            try {
                const res = await API.get('adminWebTools','/ago',myInit)
                //console.log('res: '+JSON.stringify(res))
                updateRes(res)
                if('detail' in res)
                {
                    if(res['detail'].includes("token"))
                    {
                        refreshJwt()
                    }
                }
                updateIsLoading(false)
            }
            catch (e) {
                console.log('driverpricing error: '+toString(e));
                if(e.response.status === 401)
                {
                    refreshJwt()
                }
                updateIsLoading(false)
            }
            updateIsLoading(false)
        }
    }

  async function submitDiscount() {
    if(userId > 0)
    {
        updateIsLoading(true)
        var newDiscountAmount = parseFloat(discountAmount)
        const params = {
            back_end: process.env.REACT_APP_BACKEND,
            jwt: userJwt,
            api_endpoint: "api3:portal:driver_desk",
            section: "pricing",
            request_type: "POST",
            fleet_code: fleetCode,
            driver_id: userId,
            discount_amount: newDiscountAmount,
            discount_notes: discountNotes,
            discount_or_penalty: discountOrPenalty
        };
        if (useDiscountStart === true) {
            params.discount_start = discountStart;
        }
        if (useDiscountEnd === true) {
            params.discount_end = discountEnd;
        }
        const myInit = { queryStringParameters: params };
        try {
            const res = await API.get('adminWebTools','/ago',myInit)
            //console.log('res: ' + JSON.stringify(res))
            setCount(count + 1)
            if (onChanged) onChanged()
        }
        catch (e) {
            console.log('driverpricing error: '+toString(e));
            updateIsLoading(false)
        }
        updateDisplayForm(false)
        updateIsLoading(false)
    }
  }

  async function setStatus(pricingId, status) {
    if (!(userId > 0) || !pricingId) return;
    updateIsLoading(true);
    const myInit = { queryStringParameters: {
        back_end: process.env.REACT_APP_BACKEND,
        jwt: userJwt,
        api_endpoint: "api3:portal:driver_desk",
        section: "pricing",
        request_type: "POST",
        fleet_code: fleetCode,
        driver_id: userId,
        pricing_id: pricingId,
        status: status,
    }};
    try {
        await API.get('adminWebTools','/ago', myInit);
        setCount(count + 1);
        if (onChanged) onChanged();
    }
    catch (e) {
        console.log('driverpricing error: '+toString(e));
        updateIsLoading(false);
    }
  }

  function handleDiscountPrice() {
    updateDiscountOrPenalty("discount");
    updateDisplayForm(true);
  }

  function handleIncreasePrice() {
    updateDiscountOrPenalty("penalty");
    updateDisplayForm(true);
  }

  useEffect(() => {
    fetchPageData()
    },[count, userId, userJwt, fleetCode])



  return (
      <Flex
        direction="column"
      >
        <View style={{padding:"1rem"}}>
            <Divider />
            {
                is_loading ? <Loadingmini /> : 
                <Flex 
                    direction='column'
                >
                    <Heading level={2}>Driver Pricing</Heading>
                    <Text style={{width:'100%'}}>This is the history of daily pricing credit settings applied to the driver.</Text>
                    <View>
                        <Button onClick={() => setCount(count + 1)}>
                            PRESS TO GET LATEST UPDATES
                        </Button>
                    </View>
                    <Divider />
                    <Text><i>Hint: To search, long-click on mobile or click top-right on pc.</i></Text>
                    <View style={{width:"100%"}}>
                        <View 
                            theme={themeQuartz} //className="ag-theme-quartz" // applying the grid theme
                            style={{ height: 500 }} // the grid will fill the size of the parent container
                        >
                                <AgGridReact
                                    rowData={res.rows}
                                    columnDefs={columns}
                                    rowSelection={multiRowSelection}
                                    paginationPageSize={500}
                                    paginationPageSizeSelector={[10, 25, 50]}
                                    enableCellTextSelection={true}
                                />
                        </View>
                    </View>
                    
                        { //isAdminOrFleet === false ? undefined :
                            display_form === false ? 
                                <Flex direction="column" gap="1rem" >
                                    <Button onClick={() => handleDiscountPrice()}>DISCOUNT PRICE</Button>
                                    <Button onClick={() => handleIncreasePrice()}>INCREASE PRICE</Button>
                                </Flex>
                            : 
                                <Flex direction="column" gap="1rem" >
                                    <Heading level={2}>Driver Pricing</Heading>
                                    <Text>Enter the dollars per day and the dates. Leaving the end off lasts one year from the start. A discount cannot run longer than one year.</Text>
                                    <TextField 
                                        placeholder='daily discount amount'
                                        onInput={(e) => updateDiscountAmount(e.target.value)} />
                                    
                                    <TextField
                                        placeholder='notes on why'
                                        onInput={(e) => updateDiscountNotes(e.target.value)}
                                    ></TextField>

                                    <SwitchField
                                        onChange={(e) => {
                                        updateUseDiscountStart(e.target.checked);
                                        }}
                                        value={useDiscountStart} 
                                        label={<p style={{fontSize:"0.8em", width:"50%"}}>{useDiscountStart ? "Start on Selected Date" : "Start Immediately"}</p>}
                                    />
                                    {
                                        useDiscountStart === false ? undefined :
                                        <View>
                                            <DatePicker
                                                name="Range Start"
                                                selected={discountStartFull}
                                                onChange={(date) => handleStartDateSelected(date)}
                                                dateFormat="yyyy-MM-d"
                                                timeIntervals={60}
                                            />
                                            <br/><br/>
                                        </View> 
                                    }

                                    <SwitchField
                                        onChange={(e) => {
                                        updateUseDiscountEnd(e.target.checked);
                                        }}
                                        value={useDiscountEnd} 
                                        label={<p style={{fontSize:"0.8em", width:"50%"}}>{useDiscountEnd ? "End on Selected Date" : "End one year after the start"}</p>}
                                    />

                                    {
                                        useDiscountEnd === false ? undefined :
                                        <View>
                                            <DatePicker
                                                name="Range End"
                                                selected={discountEndFull}
                                                onChange={(date) => handleEndDateSelected(date)}
                                                dateFormat="yyyy-MM-d"
                                                timeIntervals={60}
                                            />
                                            <br/><br/>
                                        </View> 
                                    }


                                    <br/>
                                    <Button onClick={() => submitDiscount()}>SUBMIT</Button>
                                    <br/>
                                    <Button onClick={() => updateDisplayForm(false)}>CANCEL</Button>
                                </Flex>
                        }
                    <Divider />
                </Flex>
            }
        </View>
      </Flex>
  );
}
